import { useModulePathname } from "../../../layouts/main/ModuleNavigation";
import { getMenuPermissionsForPath, useMenuAccessStore } from '../../../store/menuAccessStore';

// A copied scheme is created as a new record even though it opens on an edit/:id URL.
export const useSchemeSavePermission = (isCopyScheme) => {
    const modulePathname = useModulePathname();

    const permissionsByRoute = useMenuAccessStore((state) => state.permissionsByRoute);
    const permission = isCopyScheme ? 'add' : 'update';

    return getMenuPermissionsForPath(permissionsByRoute, modulePathname)?.[permission] === true;
};
